<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon icon="fas fa-laptop-house" />
        <span class="ml-1">供應商資料</span>
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Project Type -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="供應商編號："
                  label-for="id"
                  label-cols-md="3"
                  class="required"
                >
                  <div class="">
                    {{
                      newSupplierData.user_number
                        ? newSupplierData.user_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  label="狀態："
                  label-for="is_active"
                  label-cols-md="3"
                >
                  <b-form-checkbox
                    style="margin-top: 5px"
                    checked="true"
                    value="1"
                    v-model="newSupplierData.is_active"
                    class="custom-control-success"
                    name="check-button"
                    switch
                    inline
                  />

                  <span style="position: relative; top: -5px">{{
                    newSupplierData.is_active ? "啟用" : "禁用"
                  }}</span>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr class="w-100" />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                  <b-form-group
                    label="供應商名稱(中文)："
                    label-for="name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="name_cn"
                      v-model="newSupplierData.name_cn"
                      placeholder="輸入供應商名稱(中文)"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                >
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="newSupplierData.name"
                      placeholder="輸入系統帳號名稱"
                      :state="getValidationState(validationContext)"
                      @blur="checkUserName"
                    />
                    <label
                      v-if="errorNameMessage && newSupplierData.name"
                      class="text-danger"
                    >
                      {{ errorNameMessage }}
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr class="w-100" />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_company_name_cn"
                >
                  <b-form-group
                    label="聯絡人姓名(中文)："
                    label-for="company_name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="company_name_cn"
                      v-model="newSupplierData.company_name_cn"
                      placeholder="輸入聯絡人姓名(中文)"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="聯絡人姓名(英文)"
                  rules="required"
                > -->
                <b-form-group
                  label="聯絡人姓名(英文)："
                  label-for="company_name_en"
                  label-cols-md="3"
                >
                  <!-- class="required" -->
                  <b-form-input
                    id="company_name_en"
                    v-model="newSupplierData.company_name_en"
                    placeholder="輸入聯絡人姓名(英文)"
                  />

                  <!-- :state="getValidationState(validationContext)"
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>

              <b-col cols="12">
                <hr class="w-100" />
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_phone"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="c_phone"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_phone"
                      v-model="newSupplierData.phone"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                      @blur="handlePhoneChange"
                    />
                    <label
                      v-if="errorPhoneMessage && newSupplierData.phone"
                      class="text-danger"
                    >
                      {{ errorPhoneMessage }}
                    </label>
                    <label
                      v-if="newSupplierData.phone && newSupplierData.phone2"
                      class="text-danger"
                    >
                      聯絡電話及備用電話號碼不能一樣
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- email -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="電郵地址："
                  label-for="supplier_email"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="supplier_email"
                    v-model="newSupplierData.email"
                    placeholder="輸入電郵地址"
                    @blur="checkUserEmail"
                  />
                  <label
                    v-if="errorEmailMessage && newSupplierData.email"
                    class="text-danger"
                  >
                    {{ errorEmailMessage }}
                  </label>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr class="w-100" />
              </b-col>

              <!-- position -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="職位："
                  label-for="supplier_eposition"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="supplier_eposition"
                    v-model="newSupplierData.position"
                    placeholder="輸入職位"
                  />
                </b-form-group>
              </b-col>

              <!-- address -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="公司地址："
                  label-for="supplier_address"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="supplier_address"
                    v-model="newSupplierData.address"
                    placeholder="輸入公司地址"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr class="w-100" />
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="銀行名稱："
                  label-for="bank_id"
                  label-cols-md="3"
                >
                  <v-select
                    id="bank_id"
                    v-model="newSupplierData.bank_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="bankOptions"
                    :clearable="false"
                    label="name"
                    :reduce="(option) => option.id"
                    placeholder="選擇銀行名稱"
                    :filter="bankSearch"
                  >
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="戶口號碼："
                  label-for="bank_account"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="bank_account"
                    v-model="newSupplierData.bank_account"
                    placeholder="輸入戶口號碼"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <b-col cols="12" md="6" v-if="false">
                <b-form-group
                  label="加入日期："
                  label-for="join_date"
                  label-cols-md="3"
                >
                  <flat-pickr
                    v-model="newSupplierData.join_date"
                    class="form-control"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                    placeholder="輸入YYYY-MM-DD"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-1" v-if="newSupplierData.id == 0">
              <!-- Field: Password -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="密碼"
                  rules="required|min:8"
                  vid="v_password"
                >
                  <b-form-group
                    class="required"
                    label="密碼"
                    label-for="password"
                    label-cols-md="3"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password"
                        :type="passwordFieldType"
                        :state="getValidationState(validationContext)"
                        v-model="newSupplierData.password"
                        name="password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- Field: Password Confirm -->
              <b-col cols="12" md="6" v-if="newSupplierData.id == 0">
                <validation-provider
                  #default="validationContext"
                  name="確認密碼"
                  rules="required|min:8|confirmed:v_password"
                >
                  <b-form-group
                    class="required"
                    label="確認密碼"
                    label-for="password_confirmation"
                    label-cols-md="3"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password_confirmation"
                        :type="passwordConfirmFieldType"
                        :state="getValidationState(validationContext)"
                        v-model="newSupplierData.password_confirmation"
                        name="password_confirmation"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordConfirmToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
              v-if="(newSupplierData.id > 0 && ability.can('update', 'setting_suppliers')) || (newSupplierData.id == 0 && ability.can('create', 'setting_suppliers'))"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import uploadFile from "@/layouts/components/file/uploadFile.vue";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      ability,
      required,
      errorNameCnMessage: null,
      errorNameMessage: null,
      errorPhoneMessage: null,
      errorEmailMessage: null,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  methods: {
    hide() {
      this.$router.replace("/users/list");
    },
    changePassword() {
      this.newSupplierData.password =
        "WF_" + this.newSupplierData.phone.toString().slice(-4) + "_dc";
      this.newSupplierData.password_confirmation =
        "WF_" + this.newSupplierData.phone.toString().slice(-4) + "_dc";
    },
    handlePhoneChange(){
      this.changePassword();
      this.checkUserPhone();
    },
    checkUserNameCn() {
      store.dispatch('app/checkUserNameCn', {
        id: this.newSupplierData.id ? this.newSupplierData.id : null,
        name_cn: this.newSupplierData.name_cn
      }).then((response) => {
        this.errorNameCnMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameCnMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserName() {
      store.dispatch('app/checkUserName', {
        id: this.newSupplierData.id ? this.newSupplierData.id : null,
        name: this.newSupplierData.name
      }).then((response) => {
        this.errorNameMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserPhone() {
      store.dispatch('app/checkUserPhone', {
        id: this.newSupplierData.id ? this.newSupplierData.id : null, 
        phone: this.newSupplierData.phone
      }).then((response) => {
        this.errorPhoneMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorPhoneMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserEmail() {
      store.dispatch('app/checkUserEmail', {
        id: this.newSupplierData.id ? this.newSupplierData.id : null, 
        email: this.newSupplierData.email
      }).then((response) => {
        this.errorEmailMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorEmailMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    bankSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    onSubmit() {
      if ( this.errorEmailMessage || this.errorPhoneMessage || this.errorNameCnMessage){
        return false
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app/checkUserNameCn", {
              id: this.newSupplierData.id,
              name_cn: this.newSupplierData.name_cn
            })
            .then(() => {
              store
                .dispatch("app/checkUserPhone", {
                  id: this.newSupplierData.id,
                  phone: this.newSupplierData.phone,
                })
              })
            .then(() => {
              if (this.newSupplierData.email) {
                return store.dispatch("app/checkUserEmail", {
                  id: this.newSupplierData.id,
                  email: this.newSupplierData.email,
                });
              }
            })
            .then(() => {
              this.newSupplierData.is_active = this.newSupplierData.is_active ? 1 : 0;
              // 只有在 checkUserPhone 成功後才執行 addCustomer
              return store.dispatch(
                "supplier/editSupplier",
                this.newSupplierData
              );
            })
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(
                  error.response?.data?.message || error.message
                ),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
  },
  props: {
    supplierData: {
      type: Object,
      required: true,
    },

    bankOptions: {
      type: Array,
      required: true,
    },
    paymentMethodStatusOptions: {
      type: Array,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newSupplierData = ref({ id: 0, is_active: 1 });

    watch(
      () => props.supplierData,
      (newVal) => {
        newSupplierData.value = { ...newVal };
      }
    );
    const resetWorkData = () => {
      newSupplierData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          is_active: 1,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    const passwordFieldType = ref("password");
    const passwordConfirmFieldType = ref("password");

    const togglePasswordVisibility = () => {
      passwordFieldType.value =
        passwordFieldType.value === "password" ? "text" : "password";
      passwordConfirmFieldType.value =
        passwordConfirmFieldType.value === "password" ? "text" : "password";
    };

    const passwordToggleIcon = computed(() =>
      passwordFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon"
    );
    const passwordConfirmToggleIcon = computed(() =>
      passwordConfirmFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon"
    );

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newSupplierData,
      passwordFieldType,
      passwordConfirmFieldType,
      togglePasswordVisibility,
      passwordToggleIcon,
      passwordConfirmToggleIcon,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>
